export const ReportFilter = {
    "All Open Disability": {
        ReportingPeriod: "Reporting period",
        ClaimCoverageTypes: "Coverage type",
        ClaimStatus: "Status",
        PolicyAndDivisions: "Policies and divisions",
    },
    "Disability Details": {
        ReportingPeriod: "Reporting period",
        EffectiveStartDt: "From date",
        EffectiveEndDt: "To date",
        ClaimCoverageTypes: "Coverage type",
        ClaimStatus: "Status",
        ReportingPeriodDateTypeDisability: "Apply Reporting Period To",
        PolicyAndDivisions: "Policies and divisions",
    },
    "STD Only Details": {
        ReportingPeriod: "Reporting period",
        EffectiveStartDt: "From date",
        EffectiveEndDt: "To date",
        ClaimCoverageTypes: "Coverage type",
        ClaimStatus: "Status",
        ReportingPeriodDateTypeDisability: "Apply Reporting Period To",
        PolicyAndDivisions: "Policies and divisions",
    },
    "LTD Only Details": {
        ReportingPeriod: "Reporting period",
        EffectiveStartDt: "From date",
        EffectiveEndDt: "To date",
        ClaimCoverageTypes: "Coverage type",
        ClaimStatus: "Status",
        ReportingPeriodDateTypeDisability: "Apply Reporting Period To",
        PolicyAndDivisions: "Policies and divisions",
    },
    "All Open Leaves": {
        ReportingPeriod: "Reporting period",
        LeaveCoverageType: "Coverage type",
        LeaveStatus: "Status",
        IncludeHistoricalLeave: "Include historical leave",
        PeriodScheduleTypes: "Leave Schedule Type",
        ReportingGroups: "Reporting group",
    },
    "Leave Summary": {
        ReportingPeriod: "Reporting period",
        EffectiveStartDt: "From date",
        EffectiveEndDt: "To date",
        LeaveCoverageType: "Coverage type",
        LeaveStatus: "Status",
        IncludeHistoricalLeave: "Include historical leave",
        PeriodScheduleTypes: "Leave Schedule Type",
        ReportingPeriodDateTypeLeave: "Apply Reporting Period To",
        ReportingGroups: "Reporting group",
    },
    "Leave Period Protection Detail": {
        ReportingPeriod: "Reporting period",
        EffectiveStartDt: "From date",
        EffectiveEndDt: "To date",
        LeaveCoverageType: "Coverage type",
        LeaveStatus: "Status",
        IncludeHistoricalLeave: "Include historical leave",
        PeriodScheduleTypes: "Leave Schedule Type",
        PeriodStatuses: "Plan request status",
        ProtectionStatuses: "Protection status",
        ReportingPeriodDateTypeLeave: "Apply Reporting Period To",
        ReportingGroups: "Reporting group",
    },
    "Leave Details": {
        ReportingPeriod: "Reporting period",
        EffectiveStartDt: "From date",
        EffectiveEndDt: "To date",
        LeaveCoverageType: "Coverage type",
        LeaveStatus: "Status",
        IncludeHistoricalLeave: "Include historical leave",
        PeriodScheduleTypes: "Leave Schedule Type",
        PeriodStatuses: "Plan request status",
        ProtectionStatuses: "Protection status",
        ReportingPeriodDateTypeLeave: "Apply Reporting Period To",
        ReportingGroups: "Reporting group",
    },
    "Intermittent Leave": {
        ReportingPeriod: "Reporting period",
        EffectiveStartDt: "From date",
        EffectiveEndDt: "To date",
        LeaveCoverageType: "Coverage type",
        LeaveStatus: "Status",
        IncludeHistoricalLeave: "Include historical leave",
        PeriodStatuses: "Plan request status",
        ProtectionStatuses: "Protection status",
        ReportingPeriodDateTypeLeave: "Apply Reporting Period To",
        ReportingGroups: "Reporting group",
        LeaveScheduleTypes: "Leave Schedule Type",
    },
    "Accommodation Report (TL)": {
        ReportingPeriod: "Reporting period",
        EffectiveStartDt: "From date",
        EffectiveEndDt: "To date",
        LeaveCoverageType: "Coverage type",
        LeaveStatus: "Status",
        ReportingGroups: "Reporting group",
    },
    "Leave As Accommodation Report (TL)": {
        ReportingPeriod: "Reporting period",
        EffectiveStartDt: "From date",
        EffectiveEndDt: "To date",
        LeaveCoverageType: "Coverage type",
        LeaveStatus: "Status",
        IncludeHistoricalLeave: "Include historical leave",
        PeriodScheduleTypes: "Leave Schedule Type",
        ReportingPeriodDateTypeLeave: "Apply Reporting Period To",
        ReportingGroups: "Reporting group",
    },
    "Continuous Leave": {
        ReportingPeriod: "Reporting period",
        EffectiveStartDt: "From date",
        EffectiveEndDt: "To date",
        LeaveCoverageType: "Coverage type",
        LeaveStatus: "Status",
        IncludeHistoricalLeave: "Include historical leave",
        PeriodStatuses: "Plan request status",
        ProtectionStatuses: "Protection status",
        ReportingGroups: "Reporting group",
        LeaveScheduleTypes: "Leave Schedule Type",
    },
    "Reduced Schedule Leave": {
        ReportingPeriod: "Reporting period",
        EffectiveStartDt: "From date",
        EffectiveEndDt: "To date",
        LeaveCoverageType: "Coverage type",
        LeaveStatus: "Status",
        IncludeHistoricalLeave: "Include historical leave",
        PeriodStatuses: "Plan request status",
        ProtectionStatuses: "Protection status",
        ReportingGroups: "Reporting group",
        LeaveScheduleTypes: "Leave Schedule Type",
    },
    "All Open Absences": {
        ReportingPeriod: "Reporting period",
        LeaveCoverageType: "Coverage type",
        LeaveStatus: "Status",
        IncludeHistoricalLeave: "Include historical leave",
        PeriodScheduleTypes: "Leave Schedule Type",
        PolicyAndDivisions: "Policies and divisions",
        ReportingGroups: "Reporting group",
    },
    "Absence Summary": {
        ReportingPeriod: "Reporting period",
        EffectiveStartDt: "From date",
        EffectiveEndDt: "To date",
        LeaveCoverageType: "Coverage type",
        LeaveStatus: "Status",
        IncludeHistoricalLeave: "Include historical leave",
        PeriodScheduleTypes: "Leave Schedule Type",
        ReportingPeriodDateTypeAbsence: "Apply Reporting Period To",
        PolicyAndDivisions: "Policies and divisions",
        ReportingGroups: "Reporting group",
    },
    "Absence Overview": {
        ReportingPeriod: "Reporting period",
        EffectiveStartDt: "From date",
        EffectiveEndDt: "To date",
        LeaveCoverageType: "Coverage type",
        LeaveStatus: "Status",
        IncludeHistoricalLeave: "Include historical leave",
        PeriodScheduleTypes: "Leave Schedule Type",
        PeriodStatuses: "Plan request status",
        ProtectionStatuses: "Protection status",
        ReportingPeriodDateTypeAbsence: "Apply Reporting Period To",
        PolicyAndDivisions: "Policies and divisions",
        ReportingGroups: "Reporting group",
    },
    "Payment Details": {
        ReportingPeriod: "Reporting period",
        EffectiveStartDt: "From date",
        EffectiveEndDt: "To date",
        ClaimCoverageTypes: "Coverage type",
        PaymentStatuses: "Payment status",
        PolicyAndDivisions: "Policies and divisions",
    },
    "Life Waiver of Premium": {
        ReportingPeriod: "Reporting period",
        EffectiveStartDt: "From date",
        EffectiveEndDt: "To date",
        ClaimCoverageTypes: "Coverage type",
        PaymentStatuses: "Status",
        PolicyAndDivisions: "Policies and divisions",
    },
    "Life - Paid Claims": {
        ReportingPeriod: "Reporting period",
        EffectiveStartDt: "From date",
        EffectiveEndDt: "To date",
        ClaimCoverageTypes: "Coverage type",
        PaymentStatuses: "Payment status",
        PolicyAndDivisions: "Policies and divisions",
    },
    "Life - Pending Claims": {
        ReportingPeriod: "Reporting period",
        EffectiveStartDt: "From date",
        EffectiveEndDt: "To date",
        ClaimCoverageTypes: "Coverage type",
        PolicyAndDivisions: "Policies and divisions",
    },
};
export const PREVIOUS_DAY_SUBVIEWS = ["Payment Details", "Leave Changes"];
export const PREVIOUS_DAY_PERIODS = ["Prior Business Day", "Previous day"];
export const REPORTING_PERIOD_DAYS_TO_ADD = 90;
export const reportingPeriodDateTypeKeys = [
    "ReportingPeriodDateTypeLeave",
    "ReportingPeriodDateTypeClaim",
    "ReportingPeriodDateTypeLife",
    "ReportingPeriodDateTypePayment",
    "ReportingPeriodDateTypeAbsence",
    "ReportingPeriodDateTypeDisability",
];
export const reportingPeriodValueMap = {
    // Leave
    leaveStatusEffectiveDt: "Current Status Date",
    leaveReceivedDt: "Received Date",
    leaveStartDt: "Leave Start Date",
    // Disability / Claims
    claimReceivedDt: "Received Date",
    claimEffectiveDt: "Current Status Date",
    claimStatusEffectiveDt: "Current Status Date",
    disabilityBeginDt: "Disability Date",
    // Life
    lifeClaimReceivedDt: "Received Date",
    lifeClaimEffectiveDt: "Current Status Date",
    // Payment
    paymentDt: "Payment Date",
    paymentIssueDt: "Payment Issue Date",
    //
    activeAbsenceDates: "Active Absence Date",
};
// Payment status simplification configuration
export const PAYMENT_STATUS_CONFIG = [
    { keys: ["paid"], display: "Paid" },
    {
        keys: ["reversal - complete", "reversal of advice"],
        display: "Reversal",
    },
    { keys: ["stop - complete"], display: "Stop" },
    { keys: ["advised"], display: "Advised" },
    { keys: ["active"], display: "Active" },
    { keys: ["cancelled"], display: "Cancelled" },
    { keys: ["replaced"], display: "Replaced" },
    { keys: ["refund - complete", "repayment"], display: "Repayment" },
];
//Life paid report payment status
export const LIFE_PAID_PAYMENT_STATUS_CONFIG = [
    { keys: ["paid"], display: "Paid" },
    { keys: ["reversal - complete"], display: "Reversal - Complete" },
    { keys: ["refund - complete", "refund"], display: "Refund - Complete" },
    { keys: ["stop - complete"], display: "Stop - Complete" },
];
// Protection status simplification configuration
export const PROTECTION_STATUS_CONFIG = [
    { keys: ["approved"], display: "Approved" },
    { keys: ["approved - non-count"], display: "Approved - Non-Count" },
    { keys: ["cancelled"], display: "Cancelled" },
    { keys: ["denied", "rejected", "denied - ada"], display: "Denied" },
    { keys: ["denied - ada"], display: "Denied - ADA" },
    { keys: ["inactive - ada"], display: "Inactive - ADA" },
    {
        keys: ["pending", "pending evidence", "accepted", "undecided"],
        display: "Pending",
    },
];
export const COVERAGE_TYPE_CONFIG = [
    {
        keys: ["life"],
        display: "Life & AD&D"
    }
];
// Status simplification configuration
export const STATUS_CONFIG = [
    {
        keys: [
            "open",
            "approved",
            "future claim",
            "open - reasons",
            "pending evaluation",
            "pending review",
            "review complete",
            "pre-file",
            "received",
            "pending additional information",
            "pre-approved future claim",
            "create new 30 day reminder",
            "intake in progress",
        ],
        display: "Open",
    },
    {
        keys: ["pended", "new"],
        display: "New",
    },
    {
        keys: [
            "closed",
            "closed-litigation",
            "cancelled",
            "closed-approved",
            "closed - approved",
            "denied",
        ],
        display: "Closed",
    },
];
// Configuration for combining multiple fields into one for specific subviews
export const FIELD_COMBINATION_CONFIG = {
    "All Open Absences": {
        "Coverage type": ["LeaveCoverageType", "ClaimCoverageTypes"],
        Status: ["LeaveStatus", "ClaimStatus"],
    },
    "Absence Overview": {
        "Coverage type": ["LeaveCoverageType", "ClaimCoverageTypes"],
        Status: ["LeaveStatus", "ClaimStatus"],
    },
    "Absence Summary": {
        "Coverage type": ["LeaveCoverageType", "ClaimCoverageTypes"],
        Status: ["LeaveStatus", "ClaimStatus"],
    },
    "Life Waiver of Premium": {
        Status: ["PaymentStatuses", "ClaimStatus"],
    },
};
